module.exports = __webpack_public_path__ + "static/media/INTRODUCTION_PRETTY.3576e20f.png";